import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Modal, Row, Select, Switch } from "antd";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Add, Delete } from "@mui/icons-material";
import { ProductInventoryCredentialsSchema } from "../../../../../validattion";
import { yupResolver } from "@hookform/resolvers/yup";
import numeral from "numeral";

const { Option } = Select;

const ProducesModal = (props) => {
  const {
    visible,
    formMode,
    closeModal,
    one_product_inventory,
    CreateProductInventory,
    UpdateProductInventory,
    GetAllProducts,
    allProducts,
    GetAllRawMaterials,
    allRawMaterials,
  } = props;
  const [loading, setLoading] = useState(false);
  const [validate, setValidate] = useState(false);
  const checkMode = formMode === "CREATE_MODE";

  const {
    handleSubmit,
    reset,
    control,
    register,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      raw_materials: [{ raw_material: "", quantity: "" }],
      expenses: [{ name: "", cost: "" }],
      product: "",
      quantity: "",
    },
    resolver: yupResolver(ProductInventoryCredentialsSchema),
  });

  const {
    fields: rawMaterialsFields,
    append: rawMaterialAppend,
    remove: rawMaterialRemove,
  } = useFieldArray({
    control,
    name: "raw_materials",
  });

  const {
    fields: expensesFields,
    append: expensesAppend,
    remove: expensesRemove,
  } = useFieldArray({
    control,
    name: "expenses",
  });

  const getProductRecords = async () => {
    const res = await GetAllProducts();
    if (!res.success) {
      setLoading(false);
      toast.error(`Error`);
    }
  };
  const getRawMaterialsRecords = async () => {
    const res = await GetAllRawMaterials();
    if (!res.success) {
      setLoading(false);
      toast.error(`Error`);
    }
  };
  useEffect(() => {
    getProductRecords();
    getRawMaterialsRecords();
  }, [GetAllProducts, GetAllRawMaterials]);

  const closeProducesModal = () => {
    reset();
    closeModal();
  };

  const ProducesInventory = async (data) => {
    setLoading(true);
    if (formMode === "CREATE_MODE") {
      const res = await CreateProductInventory(data);
      if (res.success) {
        setLoading(false);
        toast.success("Product Inventory Created Successfully", {
          pauseOnHover: false,
        });
        closeProducesModal();
        requestAnimationFrame(() => {
          closeProducesModal();
          setLoading(false);
        });
      } else if (!res.success && res.message === undefined) {
        setLoading(false);
        toast.error("Network Error", {
          pauseOnHover: true,
        });
      } else {
        setLoading(false);
        toast.error(res.message, {
          pauseOnHover: true,
        });
      }
      setLoading(false);
    } else if (formMode === "UPDATE_MODE") {
      const updateObj = {
        ...data,
        id: one_product_inventory?.id,
      };
      const res = await UpdateProductInventory(updateObj);
      if (res.success) {
        setLoading(false);
        toast.success("Product Inventory Updated Successfully", {
          pauseOnHover: false,
        });
        closeProducesModal();
        requestAnimationFrame(() => {
          closeProducesModal();
          setLoading(false);
        });
      } else if (!res.success && res.message === undefined) {
        setLoading(false);
        toast.error("Network Error", {
          pauseOnHover: true,
        });
      } else {
        setLoading(false);
        toast.error(res.message, {
          pauseOnHover: true,
        });
      }
    }
  };

  const rawMaterialsChildren = allRawMaterials
    ?.filter((el) => el?.quantity > 0)
    ?.map((obj) => {
      return (
        <Option key={obj?.id} value={obj?.id}>
          {obj?.name}
        </Option>
      );
    });

  const productsChildren = allProducts?.map((obj) => {
    return (
      <Option key={obj.id} value={obj.id}>
        {obj.name}
      </Option>
    );
  });

  const parsePrice = (formatted) => {
    const unformatted = formatted.replace(/,/g, "");
    const parsed = parseFloat(unformatted);
    return isNaN(parsed) ? 0 : parsed;
  };
  return (
    <>
      <Modal
        visible={visible}
        title={
          <h6 style={{ fontWeight: "bold" }}>
            {checkMode
              ? "Create Produce Inventory"
              : `Update Produce Inventory`}
          </h6>
        }
        footer={null}
        onCancel={closeProducesModal}
        maskClosable={false}
        width={"550px"}
      >
        <form onSubmit={handleSubmit(ProducesInventory)} autoComplete="off">
          <div className="content">
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Product</label>
                  <Controller
                    name="product"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <Select
                        placeholder="Select a product"
                        style={{ width: "100%" }}
                        name="product"
                        size="large"
                        value={value}
                        onChange={onChange}
                        // value={product}
                        // onChange={checkOnchange}
                        defaultValue={""}
                      >
                        {productsChildren}
                      </Select>
                    )}
                  />
                  {errors.product && (
                    <span className="error">{errors.product?.message}</span>
                  )}
                </Col>
              </Row>
            </div>
            <div className="form-group">
              <Row gutter={24}>
                <Col xs={24} xl={24} lg={24}>
                  <label>Quantity</label>
                  <input
                    name="quantity"
                    className="ant-input ant-input-lg"
                    placeholder="Type in Quantity"
                    type="number"
                    {...register("quantity", { required: true })}
                  />
                  {errors.quantity && (
                    <span className="error">{errors.quantity?.message}</span>
                  )}
                </Col>
              </Row>
            </div>
            <div style={{ marginTop: "1.5rem" }}>
              <h6 style={{ marginBottom: "0.5rem", fontWeight: "semibold" }}>
                Raw Materials
              </h6>
              {rawMaterialsFields.map((field, index) => {
                const raw_material_field =
                  watch("raw_materials")?.[index]?.raw_material;
                const find_raw_material_item = allRawMaterials?.find(
                  (el) => el?.id === raw_material_field
                );
                const validation_check =
                  Number(watch("raw_materials")?.[index]?.quantity) >
                  find_raw_material_item?.quantity
                    ? true
                    : false;
                return (
                  <div
                    className="form-group"
                    style={{
                      marginBottom: "1rem",
                    }}
                    key={index}
                  >
                    <Row
                      gutter={24}
                      style={{
                        marginBottom: "1rem",
                      }}
                    >
                      <Col xs={24} xl={24} lg={24}>
                        <label>Raw Material</label>
                        <Controller
                          name={`raw_materials.${index}.raw_material`}
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              placeholder="Select a raw material"
                              style={{ width: "100%" }}
                              size="large"
                              onChange={(value) => field?.onChange(value)}
                            >
                              {rawMaterialsChildren}
                            </Select>
                          )}
                        />
                        {errors?.raw_materials?.[index]?.raw_material && (
                          <span className="error">
                            {
                              errors?.raw_materials[index]?.raw_material
                                ?.message
                            }
                          </span>
                        )}
                      </Col>
                    </Row>
                    <Row
                      gutter={24}
                      style={{
                        marginBottom: "1rem",
                      }}
                    >
                      <Col xs={24} xl={24} lg={24}>
                        <label>Quantity</label>
                        <input
                          name="quantity"
                          className="ant-input ant-input-lg"
                          placeholder="Type in Quantity"
                          {...register(`raw_materials.${index}.quantity`)}
                        />
                        {validation_check && (
                          <span className="error">
                            Quantity cannot be more than selected raw material{" "}
                            quantity({find_raw_material_item?.quantity})
                          </span>
                        )}
                        {errors?.raw_materials?.[index]?.quantity && (
                          <span className="error">
                            {errors?.raw_materials[index]?.quantity?.message}
                          </span>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={24}>
                        {index > 0 && (
                          <button
                            style={{
                              background: "none",
                              border: "none",
                              float: "right",
                              margin: "1rem 0",
                            }}
                            className="del"
                            onClick={() => rawMaterialRemove(index)}
                          >
                            <Delete style={{ color: "red" }} />
                          </button>
                        )}
                      </Col>
                    </Row>
                  </div>
                );
              })}
              <Row>
                <Col xs={24}>
                  <div style={{ marginBottom: "15px" }}>
                    <Button
                      onClick={() =>
                        rawMaterialAppend({ raw_material: "", quantity: "" })
                      }
                      // onClick={addRawMaterial}
                      icon={<Add style={{ marginRight: "5px" }} />}
                      type="primary"
                    >
                      {" "}
                      Add Raw Material
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>

            <div style={{ marginTop: "1rem" }}>
              <h6 style={{ marginBottom: "0.5rem", fontWeight: "semibold" }}>
                Expenses
              </h6>
              {expensesFields.map((field, index) => (
                <div
                  className="form-group"
                  style={{
                    marginBottom: "1rem",
                  }}
                  key={index}
                >
                  <Row gutter={24}>
                    <Col xs={15} xl={15} lg={15}>
                      <label>Name</label>
                      <input
                        name="name"
                        className="ant-input ant-input-lg"
                        placeholder="Type in Name"
                        {...register(`expenses.${index}.name`)}
                      />

                      {errors?.expenses?.[index]?.name && (
                        <span className="error">
                          {errors?.expenses[index]?.name?.message}
                        </span>
                      )}
                    </Col>
                    <Col xs={9} xl={9} lg={9}>
                      <label>Cost</label>
                      <Controller
                        name={`expenses.${index}.cost`}
                        control={control}
                        render={({ field }) => {
                          const formatted = field.value
                            ? numeral(field.value).format("0,")
                            : "";
                          return (
                            <input
                              value={formatted}
                              onChange={(e) =>
                                field.onChange(parsePrice(e.target.value))
                              }
                              onBlur={(e) =>
                                field.onChange(parsePrice(e.target.value))
                              }
                              className="ant-input ant-input-lg"
                              placeholder="Type in Cost"
                            />
                          );
                        }}
                      />
                      {errors?.expenses?.[index]?.cost && (
                        <span className="error">
                          {errors?.expenses[index]?.cost?.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={24}>
                      {index > 0 && (
                        <button
                          style={{
                            background: "none",
                            border: "none",
                            float: "right",
                            margin: "1rem 0",
                          }}
                          className="del"
                          onClick={() => expensesRemove(index)}
                        >
                          <Delete style={{ color: "red" }} />
                        </button>
                      )}
                    </Col>
                  </Row>
                </div>
              ))}
              <Row>
                <Col xs={24}>
                  <div style={{ marginBottom: "15px" }}>
                    <Button
                      onClick={() => expensesAppend({ name: "", cost: "" })}
                      icon={<Add style={{ marginRight: "5px" }} />}
                      type="primary"
                    >
                      {" "}
                      Add Expenses
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <Divider />
          <Row>
            <Col xs={24} style={{ textAlign: "right" }}>
              <Button
                loading={loading}
                type="primary"
                htmlType="submit"
                style={{ marginRight: "10px" }}
              >
                {formMode === "CREATE_MODE" ? "Save" : "Update"} Inventory
              </Button>
            </Col>
          </Row>
        </form>
      </Modal>
    </>
  );
};

export default ProducesModal;
